(function () {
  'use strict';

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    // Add thousands separator
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function parseStock(value) {
    return value === '' || value == null || isNaN(parseInt(value, 10)) ? Infinity : parseInt(value, 10);
  }

  // Unique ID shared by every item of one bundle add
  function createKitId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  // ── Shampoo → conditioner matching (add-on 2 "match" mode) ─────────────────
  // Names are compared with the words "shampoo"/"conditioner" removed, so
  // "Moist Shampoo 1.3 Gallon by Hydra" matches "Moist Conditioner 1.3 Gallon by Hydra".
  var MATCH_CACHE_TTL = 30 * 60 * 1000;

  function normalizeTitle(title) {
    return String(title)
      .toLowerCase()
      .replace(/\b(shampoo|conditioner)s?\b/g, ' ')
      .replace(/[^a-z0-9.]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fetchConditionerPage(handle, page) {
    var url = '/collections/' + encodeURIComponent(handle) + '?view=c-pdp57-conditioners&page=' + page;
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  // Resolves to the collection's available conditioners, cached per session
  function loadConditioners(handle) {
    var key = 'c-pdp57-conditioners:' + handle;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key));
      if (cached && Date.now() - cached.t < MATCH_CACHE_TTL) return Promise.resolve(cached.items);
    } catch (e) {}

    return fetchConditionerPage(handle, 1).then(function (first) {
      var rest = [];
      for (var page = 2; page <= first.pages; page++) rest.push(fetchConditionerPage(handle, page));
      return Promise.all(rest).then(function (pages) {
        var items = pages.reduce(function (all, p) { return all.concat(p.items); }, first.items);
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      });
    });
  }

  // Exactly one match → that conditioner; none or several → null (never guess)
  function findConditioner(bundle) {
    var target = normalizeTitle(bundle.dataset.productTitle);
    var excludeIds = [bundle.dataset.productId, bundle.dataset.addon1ProductId];
    return loadConditioners(bundle.dataset.matchCollection).then(function (items) {
      var matches = items.filter(function (item) {
        return excludeIds.indexOf(String(item.id)) === -1 && normalizeTitle(item.title) === target;
      });
      return matches.length === 1 ? matches[0] : null;
    });
  }

  function initBundle(bundle) {
    var mainPrice    = parseInt(bundle.dataset.mainPrice, 10);
    var addon1Price  = parseInt(bundle.dataset.addon1Price, 10);
    var addon2Price  = parseInt(bundle.dataset.addon2Price, 10);
    var discountPct  = parseFloat(bundle.dataset.discountPct) || 5;
    var mainVariant  = bundle.dataset.mainVariant;
    var addon1Variant = bundle.dataset.addon1Variant;
    var addon2Variant = bundle.dataset.addon2Variant;
    var addon2Mode   = bundle.dataset.addon2Mode;

    // Shared addon-on/off state.
    // Add-on 2 only counts once it exists: always in "static", after a match in "match".
    var addon1On = bundle.dataset.addon1Mode !== 'none';
    var addon2On = addon2Mode === 'static';

    // Stock left to add (Infinity = not limited). An add-on whose remaining stock is already
    // in the cart is hidden like an out-of-stock one; the bundle hides if the main item is.
    var mainStock   = parseStock(bundle.dataset.mainStock);
    var addon1Stock = parseStock(bundle.dataset.addon1Stock);
    var addon2Stock = parseStock(bundle.dataset.addon2Stock);
    var addon1Avail = true;
    var addon2Avail = true;
    var mainAvail   = true;

    // ── Compute totals and update all displays ──────────────────────────────
    function computeAndRender() {
      // Discount is rounded down per line (not on the total) to match the cart's
      // bundle discount exactly, e.g. $6.99 x 5% = $0.34, not a share of a rounded total.
      function lineDiscount(price) { return Math.floor(price * discountPct / 100); }

      var total = mainPrice;
      var lineDiscounts = lineDiscount(mainPrice);
      var count = 1;
      if (addon1On && addon1Avail) { total += addon1Price; lineDiscounts += lineDiscount(addon1Price); count++; }
      if (addon2On && addon2Avail) { total += addon2Price; lineDiscounts += lineDiscount(addon2Price); count++; }

      var hasSavings   = count > 1;
      var discountAmt  = hasSavings ? lineDiscounts : 0;
      var bundleTotal  = total - discountAmt;

      // Separate total (full price with all checked items summed)
      var separateDisplay = total; // No markup — just the sum of checked items' prices

      // Hidden (space kept, so the row doesn't shift) when there's nothing to compare against
      bundle.querySelectorAll('.js-pdp57b-separate').forEach(function (el) {
        el.textContent = formatMoney(separateDisplay);
        el.style.visibility = hasSavings ? '' : 'hidden';
      });
      bundle.querySelectorAll('.js-pdp57b-bundle').forEach(function (el) {
        el.textContent = hasSavings ? formatMoney(bundleTotal) : formatMoney(separateDisplay);
      });
      bundle.querySelectorAll('.js-pdp57b-save-amt').forEach(function (el) {
        el.textContent = formatMoney(discountAmt);
      });
      bundle.querySelectorAll('.js-pdp57b-save-pct').forEach(function (el) {
        el.textContent = discountPct;
      });
      bundle.querySelectorAll('.js-pdp57-count').forEach(function (el) {
        el.textContent = count;
      });

      // Show/hide savings pill
      bundle.querySelectorAll('.js-pdp57b-pill').forEach(function (el) {
        el.style.display = hasSavings ? '' : 'none';
      });

      // Disable CTA when only 1 item (nothing to bundle)
      bundle.querySelectorAll('.js-pdp57-cta').forEach(function (el) {
        el.disabled = !hasSavings;
      });

      // ── Visual states ──────────────────────────────────────────────────────

      var strip1 = bundle.querySelector('.c-pdp57-var-b [data-addon-index="1"]');
      var strip2 = bundle.querySelector('.c-pdp57-var-b [data-addon-index="2"]');

      if (strip1) { strip1.classList.toggle('c-pdp57-strip-item--unchecked', !addon1On); }
      if (strip2) { strip2.classList.toggle('c-pdp57-strip-item--unchecked', !addon2On); }
    }

    // ── Wire addon checkboxes ─────────────────────────────────────────────────
    bundle.querySelectorAll('.c-pdp57-check--addon').forEach(function (check) {
      check.addEventListener('change', function () {
        var row = check.closest('[data-addon-index]');
        if (!row) return;
        var idx = parseInt(row.dataset.addonIndex, 10);
        if (idx === 1) addon1On = check.checked;
        if (idx === 2) addon2On = check.checked;
        computeAndRender();
      });
    });

    // ── ADD BUNDLE TO CART CTA ────────────────────────────────────────────────
    bundle.querySelectorAll('.js-pdp57-cta').forEach(function (cta) {
      cta.addEventListener('click', function () {
        // Fire Intelligems custom event
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'add_bundle_to_cart_click' });

        // The cart may have changed since load (e.g. the last unit was just added) — re-check first
        checkStock().then(function () {
          if (!mainAvail || !(addon1On && addon1Avail) && !(addon2On && addon2Avail)) {
            showCartError('Sorry, the rest of this bundle is already in your cart.');
            return;
          }
          addBundle();
        });
      });
    });

    function addBundle() {

        // Build items array — main product always included
        // One kit ID per bundle add, shared by all its items (used for discount management):
        // _kit_id_1 = main PDP item, _kit_id_2 = add-on 1, _kit_id_3 = add-on 2
        var kitId = createKitId();
        var items = [
          {
            id: parseInt(mainVariant, 10),
            quantity: 1,
            properties: { _bundle: 'pdp-bundle', _kit_id_1: kitId }
          }
        ];
        if (addon1On && addon1Avail) {
          items.push({
            id: parseInt(addon1Variant, 10),
            quantity: 1,
            properties: { _bundle: 'pdp-bundle', _kit_id_2: kitId }
          });
        }
        if (addon2On && addon2Avail) {
          items.push({
            id: parseInt(addon2Variant, 10),
            quantity: 1,
            properties: { _bundle: 'pdp-bundle', _kit_id_3: kitId }
          });
        }

        // Disable all CTAs during request
        var allCtas = bundle.querySelectorAll('.js-pdp57-cta');
        showCartError('');
        var savedHTMLs = [];
        allCtas.forEach(function (btn, i) {
          savedHTMLs[i] = btn.innerHTML;
          btn.disabled = true;
          btn.textContent = 'Adding…';
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              // Shopify answers 422 when stock is short (e.g. the last unit is already in the cart);
              // in that case nothing from the bundle is added
              if (!res.ok) {
                var err = new Error(data.description || data.message || 'HTTP ' + res.status);
                err.userMessage = data.description || data.message;
                throw err;
              }
              return data;
            });
          })
          .then(function () {
            // Restore CTA
            allCtas.forEach(function (btn, i) {
              btn.innerHTML = savedHTMLs[i];
              btn.disabled = false;
            });
            computeAndRender();
            checkStock();

            // Trigger cart drawer refresh — fire several events for UpCart + theme
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));

            // UpCart-specific: open the drawer
            document.dispatchEvent(new CustomEvent('upcart:open'));
            window.dispatchEvent(new CustomEvent('upcart:open'));
          })
          .catch(function (err) {
            console.error('[c-pdp57] Bundle add failed:', err);
            showCartError(err.userMessage || 'Sorry, we couldn\'t add this bundle to your cart. Please try again.');
            allCtas.forEach(function (btn, i) {
              btn.innerHTML = savedHTMLs[i];
              btn.disabled = false;
            });
            computeAndRender();
          });
    }

    // ── Stock vs cart: hide add-ons (or the bundle) with nothing left to add ──
    function applyCartStock(cart) {
      var inCart = {};
      (cart.items || []).forEach(function (item) {
        inCart[item.variant_id] = (inCart[item.variant_id] || 0) + item.quantity;
      });
      function left(variant, stock) { return stock - (inCart[parseInt(variant, 10)] || 0); }

      mainAvail   = left(mainVariant, mainStock) >= 1;
      addon1Avail = left(addon1Variant, addon1Stock) >= 1;
      addon2Avail = left(addon2Variant, addon2Stock) >= 1;

      bundle.querySelectorAll('[data-pdp57-addon1]').forEach(function (el) {
        el.classList.toggle('c-pdp57-soldout', !addon1Avail);
      });
      bundle.querySelectorAll('[data-pdp57-addon2]').forEach(function (el) {
        el.classList.toggle('c-pdp57-soldout', !addon2Avail);
      });
      var anyAddon = (bundle.dataset.addon1Mode !== 'none' && addon1Avail) || (addon2Present() && addon2Avail);
      bundle.classList.toggle('c-pdp57-bundle--soldout', !mainAvail || !anyAddon);
      computeAndRender();
    }

    function addon2Present() {
      return !!bundle.querySelector('[data-pdp57-addon2]') && !!addon2Variant;
    }

    function checkStock() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(applyCartStock)
        .catch(function (err) { console.error('[c-pdp57] Cart stock check failed:', err); });
    }

    // Inline cart error under each CTA (empty message clears it)
    function showCartError(message) {
      bundle.querySelectorAll('.js-pdp57-cta').forEach(function (cta) {
        var el = cta.nextElementSibling;
        if (!el || !el.classList.contains('c-pdp57-error')) {
          if (!message) return;
          el = document.createElement('p');
          el.className = 'c-pdp57-error';
          el.setAttribute('role', 'alert');
          cta.insertAdjacentElement('afterend', el);
        }
        el.textContent = message;
        el.hidden = !message;
      });
    }

    // ── Intersection observer — fire bundle_module_view event ─────────────────
    var viewFired = false;
    var observer = new IntersectionObserver(function (entries) {
      if (!viewFired && entries[0] && entries[0].isIntersecting) {
        viewFired = true;
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'bundle_module_view' });
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    observer.observe(bundle);

    // Initial render to set correct display values
    computeAndRender();

    // ── Add-on 2 "match" mode: find the same-line conditioner, else drop add-on 2 ──
    function dropAddon2() {
      bundle.querySelectorAll('[data-pdp57-addon2]').forEach(function (el) { el.remove(); });
      addon2On = false;
    }

    function applyConditioner(item) {
      addon2Price   = item.price;
      addon2Variant = String(item.variant);
      addon2Stock   = parseStock(item.stock);
      addon2On      = true;
      bundle.querySelectorAll('.js-pdp57-a2-img').forEach(function (img) {
        img.src = item.image;
        img.alt = item.title;
      });
      bundle.querySelectorAll('.js-pdp57-a2-name').forEach(function (el) { el.textContent = item.title; });
      bundle.querySelectorAll('.js-pdp57-a2-price').forEach(function (el) { el.textContent = formatMoney(item.price); });
      bundle.querySelectorAll('.js-pdp57-a2-label').forEach(function (el) {
        el.setAttribute('aria-label', 'Include ' + item.title);
      });
    }

    if (addon2Mode === 'match') {
      findConditioner(bundle)
        .then(function (item) {
          if (item) { applyConditioner(item); } else { dropAddon2(); }
        })
        .catch(function (err) {
          console.error('[c-pdp57] Conditioner match failed:', err);
          dropAddon2();
        })
        .then(function () {
          // No add-on left (add-on 1 hidden / out of stock and no conditioner) → no bundle
          if (!addon1On && !addon2On) {
            bundle.remove();
            return;
          }
          bundle.classList.remove('c-pdp57-bundle--matching');
          return checkStock();
        });
    } else {
      checkStock();
    }
  }

  // ── Bootstrap ───────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.c-pdp57-bundle').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
